import { useUserStore } from '@/store/user/useUserStore'
import Login from '@/pages/login'
import { useMatches } from 'react-router'
import { PERMISSIONS } from '@/layouts/constant'

type UnLoginInterceptorProps = {
  children?: React.ReactNode
}

export const UnLoginInterceptor = ({ children }: UnLoginInterceptorProps) => {
  const matches = useMatches()
  // 找到最後一個匹配 route 的 handle
  const currentHandle: any = matches[matches.length - 1]?.handle

  // 不需登入就可訪問的頁面
  const notLoginRequired = !!(currentHandle?.permissions & PERMISSIONS.NOT_LOGIN)

  const token = useUserStore((state) => state.token)
  if (!token && !notLoginRequired) return <Login />
  return children
}
